"use client";

import { useMemoizedFn } from "ahooks";
import log from "logbeacon";
import { MessageType, useBridge } from "../lib/bridge";
import {
  getTimezoneOffsetMinutes,
  PUSH_SUBSCRIPTION_STATUS,
} from "../lib/notificationPushUtils";
import { useSubscribe } from "./useSubscribe";

/**
 * 封装 App 内推送订阅的开启/关闭流程：请求 FCM token、bindToken、updateSubscription。
 * 供 useInitApp（首次打开自动订阅）与 NotificationSection（设置页开关）复用。
 */
export function useAppPushSubscription() {
  const { request } = useBridge();
  const { bindToken, updateSubscription, getPushSetting } = useSubscribe();

  const openAppPush = useMemoizedFn(async () => {
    log.debug("[useAppPushSubscription] openAppPush");
    const { data: fcmToken } = await request(MessageType.REQUEST_PUSH_TOKEN);
    log.debug("[useAppPushSubscription] openAppPush fcmToken", fcmToken);
    const now = new Date();
    await bindToken({
      token: fcmToken,
      utc_offset_minutes: getTimezoneOffsetMinutes(now),
    });
    await updateSubscription({
      status: PUSH_SUBSCRIPTION_STATUS.OPEN,
      utc_offset_minutes: getTimezoneOffsetMinutes(now),
    });
    log.debug("[useAppPushSubscription] openAppPush");
  });

  const closeAppPush = useMemoizedFn(async () => {
    await updateSubscription({
      status: PUSH_SUBSCRIPTION_STATUS.CLOSED,
      utc_offset_minutes: getTimezoneOffsetMinutes(new Date()),
    });
  });

  return { openAppPush, closeAppPush, getPushSetting };
}
